import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.fadeTimeout = setTimeout(() => this.fadeOut(), 4500)
  }

  disconnect() {
    clearTimeout(this.fadeTimeout)
    clearTimeout(this.removeTimeout)
  }

  fadeOut() {
    this.element.classList.add("opacity-0")
    this.removeTimeout = setTimeout(() => this.element.remove(), 500)
  }
}
